/* Defines a TimeZone model. */
import Backbone from 'backbone';

var TimeZone = Backbone.Model.extend({
    idAttribute: 'unitKey'
});

export default TimeZone;
